import { combineReducers } from "redux";

import getTasksReducer from "./getTasksReducer";

const analyticsReducer = combineReducers({
  getTasks: getTasksReducer,
});

export default analyticsReducer;
